module.exports = __webpack_public_path__ + "static/img/tdsmall3.032257b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/tdsmall3.jpg
// module id = mbDb
// module chunks = 0